import { useEffect, useState } from 'react'

import { relayTicketToDesktop } from '@maxus/website/lib'

// 落地页（外部系统浏览器）：检测到桌面登录回跳（?ticket + desktop=1），
// 用深链接把一次性 ticket 回传 Electron 桌面壳；浏览器内不换 token。
// 返回 relaying 供 App 根渲染「返回桌面版」页。
// 注意：按 query 参数判定而非构建目标——外部浏览器跑的是 website 构建（VITE_APP_TARGET=website）。
export const useDesktopLoginRelay = (): { relaying: boolean } => {
  const [relaying] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    return params.has('ticket') && params.get('desktop') === '1'
  })

  useEffect(
    () => {
      if (!relaying) return
      const ticket = new URLSearchParams(window.location.search).get('ticket')
      if (ticket) relayTicketToDesktop(ticket)
    },
    [relaying],
  )

  return { relaying }
}
